// extracted by mini-css-extract-plugin
module.exports = {"teams":"task-form_teams__2DAfo"};